import {useEffect} from 'react'
import {Outlet} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import i18n from 'i18n'
import {t} from 'i18next'

const AuthLayout = () => {
  useEffect(() => {
    const root = document.getElementById('root')

    if (root) root.style.height = '100%'

    return () => {
      if (root) root.style.height = 'auto'
    }
  }, [])

  const languages = [
    {code: 'fr', name: 'Français'},
    {code: 'de', name: 'Deutsch'},
    {code: 'it', name: 'Italiano'},
    {code: 'en', name: 'English'},
    {code: 'es', name: 'Español'},
    {code: 'pt', name: 'Português'},
    {code: 'sq', name: 'Shqip'},
    {code: 'tr', name: 'Türkçe'},
    {code: 'ar', name: 'العربية'},
    {code: 'fa', name: 'فارسی'},
    {code: 'ps', name: 'پښتو'},
    {code: 'ur', name: 'اردو'},
    {code: 'hi', name: 'हिन्दी'},
  ]

  const handleChangeLanguage = (lang: string) => {
    i18n.changeLanguage(lang)
    window.location.reload()
  }

  const currentLanguage = languages.find((item) => item.code === i18n.language) || languages[0]

  return (
    <div className='d-flex flex-column min-vh-100 bg-light'>
      {/* Top Navigation */}
      <div className='px-10 py-4 d-flex justify-content-between align-items-center bg-white shadow-sm'>
        <div className='d-flex align-items-center gap-3'>
          <img
            src={toAbsoluteUrl('/media/logo/horizon-logo.png')}
            alt='Horizon Genève'
            style={{
              height: '45px',
              width: 'auto',
              objectFit: 'contain',
            }}
          />
        </div>

        {/* Language Dropdown */}
        <div className='dropdown'>
          <button
            className='btn btn-light border d-flex align-items-center gap-2 px-4 py-2'
            type='button'
            data-bs-toggle='dropdown'
            aria-expanded='false'
            style={{
              borderRadius: '8px',
              minWidth: '145px',
            }}
          >
            <i
              className='fa-solid fa-globe'
              style={{
                color: '#14264b',
                fontSize: '16px',
              }}
            />

            <span
              style={{
                color: '#14264b',
                fontWeight: 600,
              }}
            >
              {t('GLOBAL.LANGUAGE')}
            </span>

            <i
              className='fa-solid fa-chevron-down ms-auto'
              style={{
                fontSize: '10px',
                color: '#7e8299',
              }}
            />
          </button>

          <ul
            className='dropdown-menu dropdown-menu-end shadow border-0 py-2'
            style={{
              minWidth: '180px',
              maxHeight: '350px',
              overflowY: 'auto',
              borderRadius: '10px',
            }}
          >
            {languages.map((language) => (
              <li key={language.code}>
                <button
                  type='button'
                  className={`dropdown-item d-flex justify-content-between align-items-center py-2 px-4 ${
                    currentLanguage.code === language.code ? 'active' : ''
                  }`}
                  onClick={() => handleChangeLanguage(language.code)}
                >
                  <span>{language.name}</span>

                  <span
                    className='ms-3'
                    style={{
                      fontSize: '11px',
                      opacity: 0.7,
                    }}
                  >
                    {language.code.toUpperCase()}
                  </span>
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Main Layout */}
      <div className='d-flex flex-grow-1'>
        <div className='col-12 col-lg-5 d-flex justify-content-center align-items-center p-10'>
          <div
            className='bg-white shadow-lg rounded-4 p-10 w-100 border-light'
            style={{maxWidth: 460}}
          >
            <Outlet />
          </div>
        </div>

        <div
          className='col-lg-7 d-none d-lg-flex flex-column justify-content-center p-10'
          style={{
            backgroundImage: `url(${toAbsoluteUrl('/media/logo/bg.jpeg')})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            position: 'relative',
          }}
        >
          <div
            style={{
              position: 'absolute',
              inset: 0,
              background: 'rgba(255,255,255,0.10)',
            }}
          />

          <div
            className='position-relative'
            style={{
              maxWidth: 420,
              marginLeft: '5%',
              marginTop: '-30%',
            }}
          >
            <div
              style={{
                color: '#b58a1d',
                fontSize: '14px',
                fontWeight: 700,
                letterSpacing: '2px',
                textTransform: 'uppercase',
                marginBottom: '14px',
              }}
            >
              {t('LOGIN.MEM_AREA')}
            </div>

            <h2
              style={{
                color: '#14264b',
                fontFamily: 'Georgia, Times New Roman, serif',
                fontSize: '48px',
                fontWeight: 500,
                lineHeight: 1.08,
                margin: 0,
                maxWidth: '360px',
              }}
            >
              {t('LOGIN.WORK_FOR_GENEVE')}
            </h2>

            <div
              style={{
                width: '42px',
                height: '2px',
                backgroundColor: '#b58a1d',
                marginTop: '24px',
                marginBottom: '24px',
              }}
            />

            <p
              style={{
                color: '#4c5565',
                fontSize: '17px',
                fontWeight: 400,
                lineHeight: 1.65,
                margin: 0,
                maxWidth: '360px',
              }}
            >
              {t('LOGIN.JOIN')}
            </p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className='text-center py-4 text-muted bg-white shadow-sm fs-6'>
        © Horizon Genève {new Date().getFullYear()}
      </div>
    </div>
  )
}

export {AuthLayout}
